export const plurifySting = (str: string, count: number) => count > 1 ? `${str}s` : str;
